import React from 'react';
import { Play, Square, RefreshCw, Zap, AlertOctagon } from 'lucide-react';

const QuickActionWidget = ({ onManualTrigger, onEmergencyStop, processingStatus }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Zap className="w-5 h-5 text-blue-600" />
        Quick Actions
      </h3>

      <div className="space-y-3">
        {/* Manual Batch Trigger */}
        <button
          onClick={() => onManualTrigger?.()}
          disabled={processingStatus === 'running'}
          className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2 font-medium transition-colors"
        >
          <Play className="w-5 h-5" />
          Trigger Manual Batch
        </button>

        {/* Force Reconciliation */}
        <button
          disabled={processingStatus === 'running'}
          className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2 font-medium transition-colors"
        >
          <RefreshCw className="w-5 h-5" />
          Force Reconciliation
        </button>

        {/* Emergency Stop */}
        <button
          onClick={() => onEmergencyStop?.()}
          disabled={processingStatus !== 'running'}
          className="w-full px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2 font-medium transition-colors"
        >
          <Square className="w-5 h-5" />
          Emergency Stop
        </button>

        {/* Divider */}
        <div className="border-t border-gray-200 my-4" />

        {/* System Status */}
        <div className="bg-gray-50 rounded-lg p-3">
          <div className="text-xs font-medium text-gray-500 mb-2">System Status</div>
          <div className="space-y-2 text-sm">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Processing Engine</span>
              <span className="flex items-center gap-1 text-green-600 font-medium">
                <div className="w-2 h-2 bg-green-500 rounded-full" />
                Online
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-600">ML Detection</span>
              <span className="flex items-center gap-1 text-green-600 font-medium">
                <div className="w-2 h-2 bg-green-500 rounded-full" />
                Active
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Auto-Resolution</span>
              <span className="flex items-center gap-1 text-green-600 font-medium">
                <div className="w-2 h-2 bg-green-500 rounded-full" />
                Enabled
              </span>
            </div>
          </div>
        </div>

        {/* Alert Notice */}
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
          <div className="flex items-start gap-2">
            <AlertOctagon className="w-4 h-4 text-orange-600 mt-0.5 flex-shrink-0" />
            <div>
              <div className="text-xs font-medium text-orange-900 mb-1">
                Processing Notice
              </div>
              <div className="text-xs text-orange-800">
                Emergency stop will halt all active batch processes immediately
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActionWidget;